import React from "react";
import { Row, Modal, Select, Button, Input, Form, message, Col, Spin, InputNumber } from 'antd';
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OnChange_Client_Header_Data, Update_Client_Header_Action } from "../../redux/TimeCardsRedux/TimeCardsActions";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./HeaderMapping.css";
import ReConsolidation from "./ReConsolidate/ReConsolidate";


const HeaderMapping = (props) => {

    const { HeaderModalFlag, setHeaderModalFlag, RcClient } = props;
    const [RCModalFlag, setRCModalFlag] = useState(false);

    const ClientHeaderData = useSelector((state) => state.rcClientHeaderReducer.ReConsolidationClientHeaderData);

    const dispatch = useDispatch();

    //Close Header Mapping
    const CloseHeaderMapping = () => {
        setHeaderModalFlag(false);
    }

    const PascalCase = (text) => {
        // Remove leading/trailing whitespace and split the string into words
        const words = text.trim().split(/\s+/);
        // Capitalize the first letter of each word and concatenate them
        const pascalCase = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
        return pascalCase;
    }

    const UpdateHeader = () => {
        console.log(RcClient)
        dispatch(Update_Client_Header_Action(RcClient, ClientHeaderData));
        setHeaderModalFlag(false);
        setRCModalFlag(true);
    }

    const OnChangeInput = (e, index) => {
        const KeyRef = Object.entries(ClientHeaderData)[index][0];
        const ModifyData = Object.entries(ClientHeaderData).map((item) => {
            if (item[0] === KeyRef) {
                item[1] = e.target.value;
            }
            return item;
        })
        const ConstructData = {};
        ModifyData.map((item) => (ConstructData[item[0]] = item[1]));

        dispatch(OnChange_Client_Header_Data(ConstructData))
    }

    const CloseRCModal = () => {
        setRCModalFlag(false);
    }

    const ReConsolidation_Triggered = () => {
        ReConsolidation(RcClient);
        setRCModalFlag(false);
    }
    return (
        <>
            <Modal open={HeaderModalFlag} onCancel={CloseHeaderMapping} closeIcon={false} okText="Update" onOk={UpdateHeader}>
                <div className="header-mapping-title">
                    <h1>Header Data of <i>"{RcClient}"</i></h1>
                </div>
                <Form labelCol={{
                    flex: "110px",

                }}>
                    <Row gutter={[16, 0]}>
                        {
                            Object.entries(ClientHeaderData).length > 0 ? Object.entries(ClientHeaderData).map((Column, index) => {
                                return (
                                    <Col span={12}>
                                        <Form.Item key={index} label={<span style={{ color: "#535457" }}>{PascalCase(Column[0])}</span>}>
                                            {typeof (Column[1]) === "number" ?
                                                <Input value={Column[1]} onChange={(e) => OnChangeInput(e, index)} />
                                                :
                                                <Input value={Column[1]} onChange={(e) => OnChangeInput(e, index)} />}

                                        </Form.Item>
                                    </Col>
                                )
                            })
                                :
                                <Spin size="large" />
                        }
                    </Row>
                </Form>
            </Modal>

            <Modal open={RCModalFlag} onCancel={CloseRCModal} closeIcon={false} onOk={ReConsolidation_Triggered} okText="Re-Consolidate" cancelText="Abort">
                <div className="rc-confirmation">
                    <ExclamationCircleOutlined className="rc-confirmation-icon" />
                    <p>Do you want to continue with Re-Consolidation?</p>
                </div>
            </Modal>

        </>
    )
}

export default HeaderMapping;